import React from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"

import "./szechenyi2020.scss"

const Szechenyi2020 = (props) => {
  return (
    <div className="szechenyi-wrapper">
      <LayoutHeaderMenu
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={"Szechenyi 2020"}
        header_shaded
        menu={props.pageContext.menu.entries}
        footer={props.pageContext.content.global_values.set_footer}
      >
        <div className="szechenyi-image">
          <img
            src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${props.pageContext.content.global_values.set_static_assets.asset_szechenyi_picture.path}`}
            alt=""
          />
        </div>
      </LayoutHeaderMenu>
    </div>
  )
}

export default Szechenyi2020
